import { render } from "./FormRfqVendor.vue?vue&type=template&id=36ac6215&scoped=true"
import script from "./FormRfqVendor.vue?vue&type=script&lang=js"
export * from "./FormRfqVendor.vue?vue&type=script&lang=js"

import "./FormRfqVendor.vue?vue&type=style&index=0&id=36ac6215&scoped=true&lang=css"
import "./FormRfqVendor.vue?vue&type=style&index=1&id=36ac6215&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ac6215"]])

export default __exports__